import { makeAutoObservable, runInAction } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { DestinationsApi } from '../../apis/destinations.api';
import { DestinationModel } from '../../models/destination.model';

export class DestinationsStore {
	private destinations: DestinationModel[] = [];
	private isLoading = false;
	private error: Error | null = null;
	private lastAdvertiserId?: id;
	private pendingFetch?: Promise<void>;

	constructor() {
		makeAutoObservable(this);
	}

	fetch(advertiserId?: id): Promise<void> {
		if (!advertiserId) {
			runInAction(() => {
				this.destinations = [];
				this.lastAdvertiserId = undefined;
				this.isLoading = false;
			});
			return Promise.resolve();
		}

		if (this.pendingFetch && String(this.lastAdvertiserId) === String(advertiserId)) {
			return this.pendingFetch;
		}

		this.lastAdvertiserId = advertiserId;
		this.setIsLoading(true);
		this.error = null;

		const params = new URLSearchParams();
		params.set('advertiserId', String(advertiserId));

		this.pendingFetch = DestinationsApi.list(params)
			.then(res => {
				runInAction(() => {
					this.destinations = res.map(destination => new DestinationModel(destination));
					this.setIsLoading(false);
					this.pendingFetch = undefined;
				});
			})
			.catch((error: Error) => {
				runInAction(() => {
					this.error = error;
					this.setIsLoading(false);
					this.pendingFetch = undefined;
				});
			});

		return this.pendingFetch;
	}

	getDestinations(): DestinationModel[] {
		return this.destinations;
	}

	getIsLoading(): boolean {
		return this.isLoading;
	}

	setIsLoading(isLoading: boolean) {
		this.isLoading = isLoading;
	}

	getError(): Error | null {
		return this.error;
	}
}
